import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiDevicechallengeValidatedevicechallengeMutationRequest,
  PostApiDevicechallengeValidatedevicechallengeMutationResponse,
  PostApiDevicechallengeValidatedevicechallenge401,
  PostApiDevicechallengeValidatedevicechallenge403,
} from "../../../types/PostApiDevicechallengeValidatedevicechallenge";

export function getPostApiDevicechallengeValidatedevicechallengeUrl() {
  return `/api/DeviceChallenge/ValidateDeviceChallenge` as const;
}

/**
 * {@link /api/DeviceChallenge/ValidateDeviceChallenge}
 */
export async function postApiDevicechallengeValidatedevicechallenge(
  data?: PostApiDevicechallengeValidatedevicechallengeMutationRequest,
  config: Partial<
    RequestConfig<PostApiDevicechallengeValidatedevicechallengeMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiDevicechallengeValidatedevicechallengeMutationResponse,
    ResponseErrorConfig<
      | PostApiDevicechallengeValidatedevicechallenge401
      | PostApiDevicechallengeValidatedevicechallenge403
    >,
    PostApiDevicechallengeValidatedevicechallengeMutationRequest
  >({
    method: "POST",
    url: getPostApiDevicechallengeValidatedevicechallengeUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
